/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleUserForUserRoleRelationVm
 */
export interface SimpleUserForUserRoleRelationVm {
    /**
     * 
     * @type {string}
     * @memberof SimpleUserForUserRoleRelationVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleUserForUserRoleRelationVm
     */
    name?: string | null;
}

export function SimpleUserForUserRoleRelationVmFromJSON(json: any): SimpleUserForUserRoleRelationVm {
    return SimpleUserForUserRoleRelationVmFromJSONTyped(json, false);
}

export function SimpleUserForUserRoleRelationVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleUserForUserRoleRelationVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SimpleUserForUserRoleRelationVmToJSON(value?: SimpleUserForUserRoleRelationVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


